module.exports = __webpack_public_path__ + "img/ii-dark.6b1706ba.png";